export default "__VITE_ASSET__c224b53e__"